export const customer = {
  // Customer Dashboard
  totalBookings: 'Total Bookings',
  noBookingsYet: 'No bookings yet',
  startExploring: 'Start exploring our cars to make your first booking!',
  recentBookings: 'Recent Bookings',
  viewDetails: 'View Details',
  bookNewCar: 'Book New Car',
}; 